export default {
  props: [],
  components: {},
  data() {
    return {};
  },
  methods: {
    showTermosDeUso() {
      // let parent = this.$parent;
      // parent.showModalTermo('footer');
      this.$root.$emit("bv::show::modal", "ModalTermos");
    }
  }
};
